<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.pengings'), $t('text.list')]"></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.serialNo"
            :placeholder="$t('order.serialNo')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.customerName"
            :placeholder="$t('menu.customers')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          ></el-input>
        </el-form-item>
        <el-form-item :prop="'categoryId'">
          <el-select
            size="small"
            v-model="searchForm.categoryName"
            :placeholder="$t('product.category')"
            clearable
            filterable
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.name"
              :value="category.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.color"
            :placeholder="$t('product.color')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.size"
            :placeholder="$t('product.size')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.specJson"
            :placeholder="$t('product.specJson')"
          />
        </el-form-item>

        <el-form-item v-if="!Permit.isFreeEdition()">
          <el-select
            size="small"
            v-model.trim="searchForm.ownerId"
            :placeholder="$t('text.owner')"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="createAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="handOverAt"
            :start-placeholder="$t('rules.startAt', [$t('text.handOverAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.handOverAt')])"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              v-if="
                Permit.canActionsConfigDealType('available') &&
                Permit.canActions('orderDeal-available')
              "
              size="mini"
              type="success"
              @click="doAvailable"
              plain
            >
              {{ $t("dealTypes.available") }}
            </el-button>
            <el-button
              v-if="
                Permit.canActionsConfigDealType('purchase') &&
                Permit.canActionsChargeEdition('orderDeal-purchase')
              "
              size="mini"
              type="warning"
              @click="doPurchase"
              plain
            >
              {{ $t("dealTypes.purchase") }}
            </el-button>
            <el-button
              v-if="
                Permit.canActionsConfigDealType('manufacture') &&
                Permit.canActions('orderDeal-manufacture')
              "
              size="mini"
              type="primary"
              @click="doManufacture"
              plain
            >
              {{ $t("dealTypes.manufacture") }}
            </el-button>

            <el-button
              v-if="
                Permit.canActionsConfigDealType('available') &&
                Permit.canActions('orderDeal-available') &&
                Permit.extendModels().includes('wms')
              "
              size="mini"
              type="info"
              @click="batchKnockInv"
              plain
            >
              {{ $t("action.knockInv") }}
            </el-button>
            <el-dropdown class="mgl10">
              <el-button type="default" size="mini">
                {{ $t("dealInfos.pause") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="doPause">
                    {{ $t("order.sign") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="doCancelPause">
                    {{ $t("order.cancel") }}{{ $t("order.sign") }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown class="mgl10" @command="selectFlag">
              <el-button type="default" size="mini">
                {{ $t("action.flag") }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(flag, index) in flags"
                  :key="index"
                  :command="flag"
                >
                  <flag :name="flag" />
                  {{ $t("flags." + flag) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">
                  {{ $t("action.downLoadChecked") }}
                </el-dropdown-item>
                <el-dropdown-item command="search">
                  {{ $t("action.downLoadSearch") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button
              class="mgl10"
              type="default"
              size="mini"
              @click="print('printA4Div')"
            >
              {{ $t("action.print") }}
            </el-button>

            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        :row-class-name="rowBgColor"
        size="mini"
        id="pendingsTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column field="flags" :title="$t('text.flag')" width="50">
          <template v-slot="{ row }">
            <span v-if="row.flags != null && row.flags != ''">
              <flag
                :name="flag"
                :size="14"
                v-for="flag in JSON.parse(row.flags)"
                :key="flag"
              ></flag>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="130"
          sortable
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <a @click="showRecord(row)">
              {{ row.serialNo }}
            </a>
            <div class="font10">{{ row.innerSerialNo }}</div>
            <div class="font10">
              <span v-if="row.pauseAt != null" class="orange mgr5">
                {{ $t("dealInfos.pause") }}
              </span>
              <span v-if="row.bargainId == null" class="orange mgr5">
                {{ $t("order.replenish") }}
              </span>
              <span
                v-if="row.bargainId != null && row.bargainDiffAmount > 0"
                class="orange mgr5"
              >
                {{ $t("payInfoInfos.no") }}
              </span>
              <span
                v-if="row.bargainId != null && row.bargainDiffAmount < 0"
                class="orange mgr5"
              >
                {{ $t("bargain.leavePayAmount") }}
              </span>
            </div>
            <span v-if="Permit.canActions('globalSalePrice')">
              <div class="font10">
                {{ $t("order.price") }}
                <currency :code="row.currency"></currency>
                {{ row.price }}
                <span v-if="row.currency !== 'CNY'">
                  ({{ row.cnyPrice | currency }})
                </span>
              </div>
              <div
                v-if="row.extraCharge != null && row.extraCharge != 0"
                class="font10"
              >
                {{ $t("order.extraCharge") }}
                <currency :code="row.currency"></currency>
                {{ row.extraCharge }}
                <span v-if="row.currency !== 'CNY'">
                  ({{ (row.cnyExtraCharge || 0) | currency }})
                </span>
              </div>
            </span>
            <div class="font10 red strong" v-if="row.rejectQty != 0">
              {{ $t("order.rejectQty") }}:{{ row.rejectQty }}次
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customer"
          :title="$t('menu.customers')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.customerName }}
            <div>
              <span v-if="row.settleType == 'now'" class="orange font10 mgr5">
                {{ $t("settleTypes.now") }}
              </span>
              <span v-if="row.customerCountry" class="font10">
                {{ $t("countries." + row.customerCountry) }}
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
            <a
              v-if="
                row.productPurchaseUrl != null && row.productPurchaseUrl != ''
              "
              :href="row.productPurchaseUrl"
              target="_blank"
              class="font10"
            >
              {{ $t("product.purchaseUrl") }}
            </a>
            <div
              class="blue"
              v-if="Permit.canActions('inquiryInquiriesManage')"
              @click="inquiry(row)"
            >
              {{ $t("action.inquiry") }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row, rowIndex }">
            <div v-if="row.dealSuggest != null" class="red">
              <raw-html-limit-number :content="row.dealSuggest" :number="4" />
            </div>
            <div>
              <i
                slot="reference"
                class="el-icon-edit fl"
                @click="editRemark(row, rowIndex)"
              />
              <raw-html-limit-number
                :content="row.remark"
                :number="10"
                type="richText"
              />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="specJson"
          :title="$t('product.specJson')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <attribute :content="row.specJson" :number="12" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          width="70"
        >
          <template v-slot="{ row }">
            <span :class="Number(row.quantity) > 1 ? 'red font18' : ''">
              {{ row.quantity }}{{ row.unit }}
            </span>
            <div>
              <el-popover
                v-if="
                  Permit.canActionsConfigDealType('purchase') &&
                  Permit.canActionsChargeEdition('orderDeal-purchase')
                "
                placement="right"
                width="560"
                trigger="click"
                @show="purchaseHistory(row)"
              >
                <el-table
                  :data="purchaseHistories"
                  style="width: 100%"
                  border
                  size="mini"
                >
                  <el-table-column
                    prop="total"
                    :label="$t('purchase.price')"
                    min-width="80px"
                  >
                    <template slot-scope="scope">{{
                      scope.row.price | currency
                    }}</template>
                  </el-table-column>
                  <el-table-column
                    prop="supplierName"
                    :label="$t('menu.suppliers')"
                    min-width="80px"
                  ></el-table-column>
                  <el-table-column
                    prop="color"
                    :label="$t('product.color')"
                    min-width="80px"
                  ></el-table-column>
                  <el-table-column
                    prop="size"
                    :label="$t('product.size')"
                    min-width="80px"
                  ></el-table-column>
                  <el-table-column
                    prop="createAt"
                    :label="$t('text.createAt')"
                    min-width="110px"
                  ></el-table-column>
                  <el-table-column
                    prop="settlementRemark"
                    :label="$t('order.settlementRemark')"
                    min-width="80px"
                  >
                    <template slot-scope="scope">
                      <raw-html-limit-number
                        :content="scope.row.settlementRemark"
                        :number="8"
                      />
                    </template>
                  </el-table-column>
                </el-table>
                <small slot="reference" class="popover-reference">{{
                  $t("action.viewPurchaseHistory")
                }}</small>
              </el-popover>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="
            !Permit.isFreeEdition() && Permit.extendModels().includes('wms')
          "
          :title="$t('order.wmsInfo')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <div
              v-for="i of row.inventories.filter((i) => i.quantity != 0)"
              :key="i.id"
              class="font10"
            >
              {{ i.shopName }}：{{ i.quantity }}/{{ i.customQuantity }}
            </div>

            <div
              v-if="row.invSimilarQty != 0"
              class="font10 blue"
              @click="getInventoryMore(row)"
            >
              同色{{ $t("text.more") }}({{ row.invSimilarQty }})
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="
            Permit.canActionsConfigDealType('purchase') &&
            Permit.canActionsChargeEdition('orderDeal-purchase')
          "
          :title="$t('menu.suppliers')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row._supplierName }}
            <div class="font10" v-if="Permit.canActions('globalPurchasePrice')">
              {{ row._supplierPrice | currency }}
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          width="110"
          sortable
        ></vxe-table-column>

        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        ></vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column field="action" :title="$t('text.action')" width="120">
          <template v-slot="{ row }">
            <el-button
              v-if="
                row.bargainId !== null &&
                Permit.canActions('orderDeal-manufacture') &&
                Permit.extendModels().includes('mes')
              "
              type="text"
              size="mini"
              @click="hang(row)"
            >
              {{ $t("action.hang") }}
            </el-button>
            <el-dropdown
              v-if="!Permit.isFreeEdition() && row.bargainId !== null"
              class="mgl10 mgr10"
            >
              <el-button type="text" size="mini">
                <a class="el-dropdown-link small-link">
                  {{ $t("action.remake") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </a>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div class="font10" @click="remake(row, 'manufacture')">
                    {{ $t("dealTypes.manufacture") }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="font10" @click="remake(row, 'purchase')">
                    {{ $t("dealTypes.purchase") }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div>
              <el-button
                v-if="
                  !row.dealType &&
                  row.follow == false &&
                  Permit.canActions('orderDeal-reject')
                "
                type="text"
                size="mini"
                @click="reject(row)"
              >
                {{ $t("action.reject") }}
              </el-button>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <!-- ======== -->
    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="show"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <el-dialog
      :title="$t('orderDealTypes.available')"
      width="60%"
      v-if="availableDialogDF"
      :visible.sync="availableDialogDF"
      :close-on-click-modal="false"
    >
      <do-available
        :orders="selectedOrders"
        @close="availableDialogDF = false"
        @updateData="doAvailableClose"
      ></do-available>
    </el-dialog>

    <el-dialog
      :title="$t('orderDealTypes.purchase')"
      width="70%"
      v-if="purchaseDialogDF"
      :visible.sync="purchaseDialogDF"
      :close-on-click-modal="false"
    >
      <do-purchase
        :orders="selectedOrders"
        @close="purchaseDialogDF = false"
        @updateData="doPurchaseClose"
      ></do-purchase>
    </el-dialog>

    <el-dialog
      :title="$t('orderDealTypes.manufacture')"
      width="60%"
      v-if="manufactureDialogDF"
      :visible.sync="manufactureDialogDF"
      :close-on-click-modal="false"
    >
      <do-manufacture
        :orders="selectedOrders"
        @close="manufactureDialogDF = false"
        @updateData="doManufactureClose"
      ></do-manufacture>
    </el-dialog>

    <el-dialog
      :title="$t('action.knockInv')"
      width="70%"
      v-if="knockInvDialogDF"
      :visible.sync="knockInvDialogDF"
      :close-on-click-modal="false"
    >
      <do-knock-inv
        :orders="selectedOrders"
        @close="knockInvDialogDF = false"
        @updateData="doKnockInvClose"
        @updateDataNoClose="doKnockInvNoClose"
      ></do-knock-inv>
    </el-dialog>

    <el-dialog
      :title="$t('rules.edit', [$t('text.remark')])"
      :close-on-click-modal="false"
      :visible.sync="editRemarkDF"
      width="50%"
    >
      <el-form label-width="80px">
        <tinymce-editor
          ref="editor"
          v-model="editRemarkObj.remark"
          :height="300"
        ></tinymce-editor>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editRemarkDoing"
          size="small"
          @click="editRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('action.reject')"
      :close-on-click-modal="false"
      :visible.sync="rejectDF"
      width="30%"
    >
      <el-form label-width="80px">
        <el-input
          size="small"
          v-model.trim="rejectObj.remark"
          type="textarea"
          :rows="2"
        />
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="rejectSubmitDoing"
          size="small"
          @click="rejectSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="rejectDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('action.remake', [$t('orderDealTypes.manufacture')])"
      width="50%"
      v-if="remakeManufactureDF"
      :visible.sync="remakeManufactureDF"
      :close-on-click-modal="false"
    >
      <do-remake-manufacture
        :order="currentRow"
        @close="remakeManufactureDF = false"
        @updateData="remakeClose"
      ></do-remake-manufacture>
    </el-dialog>

    <el-dialog
      :title="$t('action.remake', [$t('orderDealTypes.purchase')])"
      width="50%"
      v-if="remakePurchaseDF"
      :visible.sync="remakePurchaseDF"
      :close-on-click-modal="false"
    >
      <do-remake-purhase
        :order="currentRow"
        @close="remakePurchaseDF = false"
        @updateData="remakeClose"
      ></do-remake-purhase>
    </el-dialog>

    <el-dialog
      :title="$t('action.hang')"
      width="50%"
      v-if="hangDF"
      :visible.sync="hangDF"
      :close-on-click-modal="false"
    >
      <do-hang
        :order="currentRow"
        @close="hangDF = false"
        @updateData="hangClose"
      ></do-hang>
    </el-dialog>

    <div id="printA4Div" style="display: none">
      <div
        v-for="(cp, index) in selectRecords"
        :key="index"
        :style="
          'margin:20px; font-size: 24px;' +
          (index == 0 ? '' : 'page-break-before: always;')
        "
      >
        <div style="margin-bottom: 10px">
          {{ $t("order.serialNo") }}：{{ cp.serialNo }}
        </div>
        <div style="margin-bottom: 10px">
          <strong>{{ $t("product.productNo") }}:</strong>
          {{ cp.productNo }}&nbsp;&nbsp;&nbsp;&nbsp;
          <strong>{{ $t("product.color") }}：</strong>
          {{ cp.color }}&nbsp;&nbsp;&nbsp;&nbsp;
          <strong>{{ $t("product.size") }}：</strong>
          {{ cp.size }}&nbsp;&nbsp;&nbsp;&nbsp;
          <span style="float: right">
            <strong>{{ $t("menu.customers") }}：</strong>
            {{ cp.customerName }}&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>{{ $t("text.owner") }}：</strong>
            {{ cp.ownerName }}
          </span>
        </div>
        <div style="margin-bottom: 10px; clear：both">
          <strong style="float: left">{{ $t("text.remark") }}：</strong>
          <raw-html :content="cp.remark" type="richText" />
        </div>
        <br />
        <div>
          <img :src="cp.firstImage" style="max-width: 1000px" />
        </div>
      </div>
    </div>

    <!-- 询价 -->
    <el-dialog
      :title="$t('text.create')"
      :visible.sync="inquiryDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form ref="addObjForm" :model="inquiryObj" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('inquiry.type')" :prop="'type'">
              <el-radio-group v-model="inquiryObj.type">
                <el-radio label="private">{{
                  $t("inquiryTypes.private")
                }}</el-radio>
                <el-radio label="public">{{
                  $t("inquiryTypes.public")
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('inquiry.serialNo')"
              :prop="'serialNo'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('inquiry.serialNo')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="inquiryObj.serialNo"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('text.quantity')"
              :prop="'quantity'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.quantity')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="inquiryObj.quantity" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('inquiry.expirateAt')"
              :prop="'expirateAt'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('inquiry.expirateAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="inquiryObj.expirateAt"
                type="date"
                style="width: 100%"
                :picker-options="pickerTodayAfterTime"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <fieldset class="mgb15">
          <legend>{{ $t("text.explain") }}</legend>
          <el-input
            size="small"
            v-model.trim="inquiryObj.explain"
            type="textarea"
            :rows="2"
          />
        </fieldset>
        <fieldset v-if="inquiryObj.type == 'private'" class="mgb15">
          <legend>
            {{ $t("menu.suppliers") }}
            &nbsp;&nbsp;
            <el-checkbox
              size="small"
              v-model="checkAllSuppliers"
              :indeterminate="isIndeterminateSuppliers"
              @change="handleCheckAllSuppliersChange"
              >{{ $t("action.checkAll") }}</el-checkbox
            >
          </legend>
          <el-checkbox-group
            size="small"
            v-model="checkedSuppliers"
            @change="handleCheckedSuppliersChange"
          >
            <el-checkbox
              size="small"
              v-for="supplier in suppliersFilter"
              :key="supplier.id"
              :label="supplier"
              style="width: 100px"
              >{{ Util.limitText(supplier.name, 5) }}</el-checkbox
            >
          </el-checkbox-group>
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="inquiryDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="inquiryDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 更多 -->
    <el-dialog
      :title="$t('text.more')"
      :visible.sync="inventoryMoreDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <vxe-table
        :data="inventoryMore"
        class="recordsTable"
        size="mini"
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        />
        <vxe-table-column
          field="color"
          :title="$t('product.color')"
          min-width="80"
        />
        <vxe-table-column
          field="size"
          :title="$t('product.size')"
          min-width="80"
        />

        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        />
        <vxe-table-column
          field="totalLock"
          :title="$t('inventory.totalLock')"
          min-width="80"
        />
        <vxe-table-column
          field="shopName"
          :title="$t('menu.warehouses')"
          min-width="60"
        >
        </vxe-table-column>
        <vxe-table-column field="action" :title="$t('text.action')" width="80">
          <template v-slot="{ row }">
            <el-button
              v-if="row.quantity - row.totalLock >= currentRow.quantity"
              type="text"
              :loading="changeSpecSubmitDoing"
              size="small"
              @click="changeSpecSubmit(row)"
              >{{ $t("action.changeSpec") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div slot="footer" class="dialog-footer">
        <span class="font10 mgr10">
          库存/锁定：{{ invTotalQty }}/{{ invTotalLock }}
        </span>
        <el-button size="small" @click="inventoryMoreDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import { flagsWithClear, flagsWithNone } from "@/utils/enums.js";
import Currency from "@/components/Currency";
import RawHtml from "@/components/RawHtml";
import TinymceEditor from "@/components/TinymceEditor";
import DateRange from "@/components/DateRange";

import User from "@/api/user.js";
import Order from "@/api/order.js";
import OrderMes from "@/api/orderMes.js";
import Brand from "@/api/brand";
import Category from "@/api/category";
import Supplier from "@/api/supplier";
import Inquiry from "@/api/inquiry";
import Inventory from "@/api/inventory";
import Purchase from "@/api/purchase";
import Show from "../bargains/showOrder.vue";
import DoPurchase from "./purchase.vue";
import DoManufacture from "./manufacture.vue";
import DoAvailable from "./available.vue";
import DoRemakeManufacture from "./remakeManufacture.vue";
import DoRemakePurhase from "./remakePurchase.vue";
import DoHang from "./hang.vue";
import DoKnockInv from "./knockInv.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Currency,
    TinymceEditor,
    RawHtml,
    Show,
    DoPurchase,
    DoManufacture,
    DoAvailable,
    DoRemakeManufacture,
    DoRemakePurhase,
    DoHang,
    DoKnockInv,
    DateRange,
  },

  data() {
    return {
      Util: Util,
      flags: flagsWithClear,
      sorter: {
        sortBy: "orders_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "orders_productNo",
        handOverAt: "orders_handOverAt",
        serialNo: "orders_serialNo",
      },

      narrows: [
        [
          {
            label: this.$t("order.dealInfo"),
            items: [
              {
                label: this.$t("dealInfos.needDeal"),
                key: "pauseNo",
                condition: { pause: "no" },
              },
              {
                label: this.$t("dealInfos.pause"),
                key: "pauseYes",
                condition: { pause: "yes" },
                numberFun: Order.pausePendingCount,
                emitNames: ["orderBatchPause", "orderBatchRemovePause"],
              },
            ],
          },
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: "yes" },
              },
            ],
          },
          {
            label: this.$t("text.flag"),
            items: flagsWithNone.map((flag) => {
              return { flag: flag, key: flag, condition: { flag: flag } };
            }),
          },
        ],
      ],
      initFilter: "pauseNo",
      searchForm: {
        serialNo: null,
        productNo: null,
        categoryName: null,
        ownerId: null,
        customerName: null,
        createAtStartAt: null,
        createAtEndAt: null,
        handOverAtStartAt: null,
        handOverAtEndAt: null,
        color: null,
        size: null,
        specJson: null,
      },
      users: [],
      //
      selectedOrders: [],
      categories: [],
      //
      availableDialogDF: false,
      manufactureDialogDF: false,
      purchaseDialogDF: false,
      doPauseDoing: false,
      doCancelPauseDoing: false,
      //编辑备注
      currentRowIdx: null,
      editRemarkDF: false,
      editRemarkObj: {
        remark: null,
        uuid: null,
      },
      editRemarkDoing: false,
      //拒绝
      rejectDoing: false,
      row: null,
      rejectDF: false,
      rejectObj: {
        remark: null,
      },
      rejectSubmitDoing: false,
      //
      show: false,
      currentRowId: null,
      currentRow: null,

      //
      remakeManufactureDF: false,
      remakePurchaseDF: false,
      hangDF: false,
      //
      purchaseHistories: [],
      // 询价
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      inquiryDF: false,
      suppliersFilter: [],
      inquiryObj: {
        type: "private",
        serialNo: null,
        images: null,
        productNo: null,
        quantity: 1,
        expirateAt: null,
        explain: null,
        inquiryItems: [],
      },
      isIndeterminateSuppliers: false,
      checkedSuppliers: [],
      checkAllSuppliers: false,
      inquiryDoing: false,
      //
      purchaseHistories: [],
      //
      inventoryMore: [],
      inventoryMoreDF: false,
      currentRow: null,
      changeSpecSubmitDoing: false,
      invTotalQty: 0,
      invTotalLock: 0,
      //撞库
      knockInvDialogDF: false,
    };
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    axios
      .all([
        User.findByTenantId(self.Permit.currentTenant().id),
        Brand.findByTenantId(),
        Category.findByTenantId(),
      ])
      .then(
        axios.spread(function (users, brands, categories) {
          if (users.status === 200) {
            self.users = users.data.filter((u) => u.authorize === true);
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            self.brands = brands.data;
            self.narrowsBrands();
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    //撞库
    batchKnockInv() {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const replenishOrders = this.selectRecords.filter(
        (c) => c.bargainId == null
      );
      if (replenishOrders.length != 0) {
        this.$message({
          message: this.$t("prompt.replenishmentNotKnockInvDeal"),
          type: "warning",
        });
        return;
      }
      self.selectedOrders = self.selectRecords.filter(
        (c) => c.bargainId !== null
      );
      Order.knockInvByIds({ ids: self.selectedOrders.map((s) => s.id) }).then(
        function (res) {
          if (res.status == 200) {
            const knockInvsFilter = res.data.filter((r) => r.invs.length != 0);
            if (knockInvsFilter.length == 0) {
              self.$message({
                message: "撞库失败",
                type: "warning",
              });
              return;
            }
            for (let knockInv of knockInvsFilter) {
              Vue.set(
                knockInv,
                "order",
                self.selectedOrders.find((o) => o.id == knockInv.id)
              );
            }
            if (self.buildTableDataKnockInv(knockInvsFilter).length == 0) {
              self.$message({
                message: "撞库失败",
                type: "warning",
              });
              return;
            }
            self.knockInvDialogDF = true;
          } else {
            self.sysError();
          }
        }
      );
    },
    buildTableDataKnockInv(records) {
      let rs = [];
      records.forEach((element) => {
        const invsFilter = element.invs.filter(
          (i) => i.quantity - i.totalLock >= element.order.quantity
        );
        invsFilter.forEach((inv) => {
          let obj = inv;
          Vue.set(obj, "_id", element.order.id);
          Vue.set(obj, "_serialNo", element.order.serialNo);
          Vue.set(obj, "_productNo", element.order.productNo);
          Vue.set(obj, "_quantity", element.order.quantity);
          Vue.set(obj, "_images", element.order.images);
          Vue.set(obj, "_invs", invsFilter);
          rs.push(obj);
        });
      });
      return rs;
    },
    doKnockInvNoClose() {
      this.loadData();
    },
    doKnockInvClose() {
      this.clearSelected();
      this.knockInvDialogDF = false;
      this.loadData();
    },
    //
    getInventoryMore(row) {
      const self = this;
      self.currentRow = row;
      Inventory.findByProductInfoWithNoAndColor({
        productNo: row.productNo,
        color: row.color,
      }).then(function (res) {
        if (res.status == 200) {
          self.inventoryMore = res.data.filter((i) => i.quantity != 0);
          self.inventoryMoreDF = true;
          self.inventoryMoreCompute();
        } else {
          self.sysError();
        }
      });
    },
    inventoryMoreCompute() {
      const self = this;
      self.invTotalQty = 0;
      self.invTotalLock = 0;
      for (const inv of self.inventoryMore) {
        self.invTotalQty = self.invTotalQty + inv.quantity;
        self.invTotalLock = self.invTotalLock + inv.totalLock;
      }
    },
    changeSpecSubmit(row) {
      const self = this;
      const obj = {
        shopId: row.shopId,
        newSize: row.size,
        orderId: self.currentRow.id,
      };
      self.changeSpecSubmitDoing = true;
      Order.changeSpecPrepared(obj).then(function (res) {
        self.changeSpecSubmitDoing = false;
        self.inventoryMoreDF = false;
        if (res.status === 200) {
          self.sysResult(res.data);
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 采购历史
    purchaseHistory(row) {
      const self = this;
      self.purchaseHistories = [];
      const obj = {
        productNo: row.productNo,
        pageSize: 10,
      };
      Purchase.history(obj).then(function (res) {
        if (res.status === 200) {
          self.purchaseHistories = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // 新增
    inquiry(row) {
      const self = this;
      self.inquiryObj.type = "private";
      self.inquiryObj.serialNo = Util.serialNo();
      self.inquiryObj.images = row.images;
      self.inquiryObj.productNo = row.productNo;
      self.inquiryObj.expirateAt = null;
      self.inquiryObj.explain = null;
      self.inquiryObj.InquiryItems = [];
      Supplier.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.suppliers = res.data;
          self.suppliersFilter = self.suppliers.filter(
            (s) => s.sourceTenantId != null
          );
          self.inquiryDoing = false;
          self.inquiryDF = true;
        } else {
          self.sysError();
        }
      });
    },
    handleCheckAllSuppliersChange(val) {
      this.checkedSuppliers = val ? this.suppliersFilter : [];
    },
    handleCheckedSuppliersChange(value) {
      const checkedCount = value.length;
      this.checkAllSuppliers = checkedCount === this.suppliersFilter.length;
      this.isIndeterminateSuppliers =
        checkedCount > 0 && checkedCount < this.suppliersFilter.length;
    },
    addSubmit() {
      const self = this;
      if (
        self.inquiryObj.type === "private" &&
        self.checkedSuppliers.length === 0
      ) {
        self.$message({
          message: this.$t("prompt.atLeastOneSupplier"),
          type: "warning",
        });
        return;
      }
      self.$refs.addObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.inquiryObj.quantity)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.inquiryObj.inquiryItems = self.checkedSuppliers.map((c) => {
            return { supplierId: c.id, supplierTenantId: c.sourceTenantId };
          });
          self.inquiryObj.expirateAt = Util.formatDate(
            self.inquiryObj.expirateAt
          );
          self.inquiryDoing = true;
          Inquiry.insertBatch([self.inquiryObj]).then(function (res) {
            self.inquiryDoing = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.inquirySuccess"),
                type: "success",
              });
              self.loadData();
              self.inquiryDF = false;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    narrowsBrands() {
      if (this.brands.length != 0) {
        this.narrows.push([
          {
            label: this.$t("product.brand"),
            items: this.brands.map((brand) => {
              return {
                label: brand.name,
                key: brand.name,
                condition: { productBrand: brand.name },
              };
            }),
          },
        ]);
      }
    },

    // 下载
    download(type) {
      const self = this;
      if (type == "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.selectRecords.map((c) => c.id),
        };
        self.downloadData(data);
      } else {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Order.pendingsExportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },

    print(type) {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.printFunction(type);
    },
    //挂单
    hang(row) {
      const self = this;
      const data = {
        productNo: row.productNo,
        size: row.size,
        color: row.color,
        quantity: row.quantity,
      };
      OrderMes.findSameSpecReplenishs(data).then(function (res) {
        if (res.status === 200) {
          if (res.data.length === 0) {
            self.$message({
              message: self.$t("prompt.noHangReplenish"),
              type: "warning",
            });
            return;
          }
          self.currentRow = row;
          self.hangDF = true;
        } else {
          self.sysError();
        }
      });
    },
    hangClose() {
      this.loadData();
      this.hangDF = false;
    },
    // 改制
    remake(row, type) {
      this.currentRow = row;
      if (type == "manufacture") {
        this.remakeManufactureDF = true;
      } else {
        this.remakePurchaseDF = true;
      }
    },
    remakeClose() {
      this.loadData();
      this.remakeManufactureDF = false;
      this.remakePurchaseDF = false;
    },

    // 拒绝
    reject(row) {
      const self = this;
      self.row = row;
      self.rejectObj.remark = null;
      self.rejectSubmitDoing = false;
      self.rejectDF = true;
    },
    rejectSubmit() {
      const self = this;
      self.rejectSubmitDoing = true;
      Order.reject(self.row.id, self.rejectObj).then(function (res) {
        self.rejectSubmitDoing = false;
        if (res.status == 200) {
          self.loadData();
          self.$message({
            message: self.$t("prompt.rejectSuccess"),
            type: "success",
          });
          self.$eventHub.$emit("orderReject");
          self.rejectDF = false;
        } else {
          self.sysError();
        }
      });
    },
    //
    editRemark(row, rowIndex) {
      this.editRemarkObj.uuid = row.uuid;
      this.editRemarkObj.remark = row.remark;
      this.currentRowIdx = rowIndex;
      this.editRemarkDoing = false;
      this.editRemarkDF = true;
    },
    editRemarkSubmit() {
      const self = this;
      self.editRemarkDoing = true;
      Order.updateRemark(self.editRemarkObj).then(function (res) {
        self.editRemarkDoing = false;
        self.editRemarkDF = false;
        if (res.status === 200) {
          self.records[self.currentRowIdx].remark = self.editRemarkObj.remark;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    //=====
    // 标旗帜
    selectFlag(flag) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const data = [];

      for (const c of self.selectRecords) {
        const obj = { uuid: c.uuid, flags: null };
        if (flag === "clear") {
          obj.flags = JSON.stringify([]);
        } else {
          const arr = c.flags != null ? JSON.parse(c.flags) : [];
          const newArr = arr.concat([flag]);
          obj.flags = JSON.stringify(newArr);
        }
        data.push(obj);
      }
      // console.log(flag, "===", data);
      Order.updateFlags(data).then(function (res) {
        if (res.status === 200) {
          for (const o of self.selectRecords) {
            o.flags = data.find((d) => d.uuid == o.uuid).flags;
          }
          self.$message({
            message: self.$t("prompt.signSuccess"),
            type: "success",
          });
          self.clearSelected();
        } else {
          self.sysError();
        }
      });
    },

    doCancelPause() {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const rows = self.selectRecords.filter((c) => c.pauseAt !== null);

      if (rows.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneDataPause"));
        return;
      }
      self.doCancelPauseDoing = true;
      Order.batchRemovePause(rows.map((c) => c.id)).then(function (res) {
        if (res.status == 200) {
          self.doCancelPauseDoing = false;
          self.$message({
            message: self.$t("prompt.dealSuccess"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("orderBatchRemovePause");
        } else {
          self.sysError();
        }
      });
    },
    //
    doPause() {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const rows = self.selectRecords.filter((c) => c.pauseAt == null);

      if (rows.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneDataNoPause"));
        return;
      }
      self.doPauseDoing = true;
      Order.batchPause(rows.map((c) => c.id)).then(function (res) {
        if (res.status == 200) {
          self.doPauseDoing = false;
          self.$message({
            message: self.$t("prompt.dealSuccess"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("orderBatchPause");
        } else {
          self.sysError();
        }
      });
    },
    doManufacture() {
      const self = this;
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      if (self.Permit.extendModels().includes("mes")) {
        this.manufactureDialogDF = true;
        this.selectedOrders = this.selectRecords;
      } else {
        const data = self.selectRecords.map((s) => {
          return {
            id: s.id,
            costPrice: null,
            factoryId: null,
            factoryName: null,
          };
        });
        Order.batchProcessing(data).then(function (res) {
          self.dealManufactureDoing = false;
          if (res.status === 200) {
            self.sysResults(res.data, self.$t("prompt.dealSuccess"));
            self.loadData();
            self.$eventHub.$emit("orderBatchProcessing");
          } else {
            self.sysError();
          }
        });
      }
    },
    doManufactureClose() {
      this.manufactureDialogDF = false;
      this.loadData();
    },
    //
    doPurchase() {
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      this.purchaseDialogDF = true;
      this.selectedOrders = this.selectRecords;
    },
    doPurchaseClose() {
      this.purchaseDialogDF = false;
      this.loadData();
    },
    //
    doAvailable() {
      if (this.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const replenishOrders = this.selectRecords.filter(
        (c) => c.bargainId == null
      );
      if (replenishOrders.length != 0) {
        this.$message({
          message: this.$t("prompt.replenishmentNotAvailableDeal"),
          type: "warning",
        });
        return;
      }
      this.selectedOrders = this.selectRecords.filter(
        (c) => c.bargainId !== null
      );
      this.availableDialogDF = true;
    },
    doAvailableClose() {
      this.availableDialogDF = false;
      this.loadData();
    },

    showRecord(order) {
      this.currentRowId = order.id;
      this.show = true;
    },
    //======
    dataProvider(params) {
      return Order.pendingSearch(params);
    },
    async recordsDecorate(records) {
      this.records = await this.buildTableData(records);
    },
    async buildTableData(records) {
      let rs = [];
      const ordersNewRes = await Order.batchPrePurchaseing(
        records.map((o) => o.id)
      );
      if (ordersNewRes.status === 200) {
        const ordersNew = ordersNewRes.data;
        for (let r of records) {
          let obj = ordersNew.find((on) => on.id == r.id);
          if (obj != null && obj.defaultSupplier != null) {
            Vue.set(r, "_supplierName", obj.defaultSupplier.supplierName);
            Vue.set(r, "_supplierPrice", obj.defaultSupplier.price);
          } else {
            Vue.set(r, "_supplierName", null);
            Vue.set(r, "_supplierPrice", null);
          }
          rs.push(r);
        }
        return rs;
      } else {
        self.sysError();
      }
    },
    isNear(row) {
      //定义近交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (
        !noColorWorkflowStates.includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return true;
        }
      }
      return false;
    },
    isPass(row) {
      //定义过交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (
        !noColorWorkflowStates.includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
